export const SET_SESSION_EXISTS = "okta/SET_SESSION_EXISTS";
export const setSessionExists = (payload) => ({
  type: SET_SESSION_EXISTS,
  payload,
});

export const SET_USER_AGENCY_PERMISSIONS = "okta/SET_USER_AGENCY_PERMISSIONS";
export const setOktaUserAgencyPermissions = (payload) => ({
  type: SET_USER_AGENCY_PERMISSIONS,
  payload,
});

const INITIAL_STATE = {
  sessionExists: true,
  availableGroups: [],
};

const getState = (state) => state.okta;
export const getSessionExists = (state) => getState(state).sessionExists;

const reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SESSION_EXISTS:
      return {
        ...state,
        sessionExists: payload,
      };
    case SET_USER_AGENCY_PERMISSIONS:
      return {
        ...state,
        availableGroups: payload,
      };
    default:
      return state;
  }
};

export default reducer;
